import { createReducer, on } from '@ngrx/store';

import { IntercomFeedbackActions, IntercomLoaderActions, IntercomMessengerActions } from './intercom-state.actions';

export type IntercomLoadState = 'notStarted' | 'loading' | 'loaded' | 'failed';

export interface IntercomState {
  loadState: IntercomLoadState;
  jwtApplied: boolean;
  messengerOpen: boolean;
}

export const initialIntercomState: IntercomState = {
  loadState: 'notStarted',
  jwtApplied: false,
  messengerOpen: false,
};

export const intercomStateReducer = createReducer<IntercomState>(
  initialIntercomState,
  on(IntercomLoaderActions.booted, (state): IntercomState => ({ ...state, loadState: 'loading' })),
  // A late load after a timeout still wins, so the next click works
  on(IntercomLoaderActions.loaded, (state): IntercomState => ({ ...state, loadState: 'loaded' })),
  // A feedback timeout can fire after the script loaded (JWT late); keep 'loaded'
  on(
    IntercomLoaderActions.failed,
    IntercomFeedbackActions.failed,
    (state): IntercomState => (state.loadState === 'loaded' ? state : { ...state, loadState: 'failed' })
  ),
  on(IntercomLoaderActions.finJwtApplied, (state): IntercomState => ({ ...state, jwtApplied: true })),
  on(IntercomMessengerActions.shown, (state): IntercomState => ({ ...state, messengerOpen: true })),
  on(IntercomMessengerActions.hidden, (state): IntercomState => ({ ...state, messengerOpen: false }))
);
